import { render, staticRenderFns } from "./InstanceTitle.vue?vue&type=template&id=59d1b1aa&scoped=true&"
import script from "./InstanceTitle.vue?vue&type=script&lang=js&"
export * from "./InstanceTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d1b1aa",
  null
  
)

export default component.exports